import ReactGA from 'react-ga';
import axios from 'axios';
import qp from 'query-parse';

import config from '../config';

if (!window.EncTracking) window.EncTracking={queue:[],track:function(e){this.queue.push({type:"track",props:e})},identify:function(e){this.queue.push({type:"identify",props:e})}};

export const DataLayerPush = window.dataLayer && ((data) => window.dataLayer.push(data));
export const Intercom = window.Intercom && {
    update: props => {
        try {
            window.Intercom('update', props);
        } catch (e) {}
    },
    trackEvent: (eventName, eventData) => {
        try {
            window.Intercom('trackEvent', eventName, eventData);
        } catch (e) {}
    }
};

export const GTagTrackEvent = (...args) => window.gtag && window.gtag('event', ...args);
export const GA = {
    setUser: userId => ReactGA.set({ userId }),
    pageView: pageUrl => ReactGA.pageview(pageUrl),
    event: (...args) => ReactGA.event(...args),
    timing: (...args) => ReactGA.timing(...args)
};

export const EncTracking = {
    identify: props => window.EncTracking.identify(props),
    track: ({ name, properties, user }) => window.EncTracking.track({ name, properties, user })
}

export const openIntercom = () => {
    window.Intercom && window.Intercom('show');
}

const init = () => {
    if (!config.EVENTS_TRACKING_ENABLED) {
        return;
    }

    if (config.GA_TRACKING_ENABLED) {
        ReactGA.initialize(config.GA_TRACKING_ID, {
            debug: config.EVENTS_TRACKING_DEBUG,
            titleCase: false,
            gaOptions: {
                referrer: config.APP_DOMAIN
            }
        });
    }

    if ('Intercom' in window && config.INTERCOM_ENABLED) {
        window.Intercom('boot', {
            app_id: config.INTERCOM_APP_ID,
            hide_default_launcher: true
        });
    }
}

export const getUserIP = async () => {
    let ip = null;
    try {
        const { data: userQueryString } = await axios({
            method: 'get',
            url: 'https://www.cloudflare.com/cdn-cgi/trace'
        });

        ip = qp.toObject(userQueryString.replace(/\n/g, '&')).ip;
    } catch (e) {}

    return ip;
}

init();
